import type MDEditor from "@uiw/react-md-editor"
import type { RefMDEditor } from "@uiw/react-md-editor"
import React, { Suspense } from "react"
import { lazily } from "react-lazily"

import classNames from "classnames"

import { ArrayElement } from "shared/types/ArrayElement"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

const { MarkdownEditorInternal } = lazily(
  () => import("./MarkdownEditorInternal")
)

export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6] as const
export type HeadingLevel = ArrayElement<typeof HEADING_LEVELS>

export interface MarkdownEditorProps
  extends React.ComponentProps<typeof MDEditor> {
  label: string
  isLoading?: boolean
  maxLength?: number
  allowedHeadingLevels?: HeadingLevel[]
}

export const MarkdownEditor = React.memo(
  React.forwardRef(
    (props: MarkdownEditorProps, ref: React.ForwardedRef<RefMDEditor>) => (
      <Suspense
        fallback={
          <div
            className={classNames(
              props.className,
              "markdown-editor",
              "loading"
            )}
          >
            <Skeleton count={6} />
          </div>
        }
      >
        <MarkdownEditorInternal {...props} ref={ref} />
      </Suspense>
    )
  )
)
